import {
  GET_DETAIL_PHIEU_THUCHI,
  GET_DETAIL_PHIEU_THUCHI_SUCCESS,
  GET_DETAIL_PHIEU_THUCHI_FAILURE,
  GET_IN_PHIEU_THUCHI,
  GET_IN_PHIEU_THUCHI_SUCCESS,
  GET_IN_PHIEU_THUCHI_FAILURE,
  SHOW_IN_PHIEU_THUCHI,
} from "./actionTypes";

export const getDetailPhieuThuChi = (dataSearch) => ({
  type: GET_DETAIL_PHIEU_THUCHI,
  dataSearch,
});

export const getDetailPhieuThuChiSuccess = (data) => ({
  type: GET_DETAIL_PHIEU_THUCHI_SUCCESS,
  payload: data,
});

export const getDetailPhieuThuChiFailure = () => ({
  type: GET_DETAIL_PHIEU_THUCHI_FAILURE,
});

export const getInPhieuThuChi = (dataSearch) => ({
  type: GET_IN_PHIEU_THUCHI,
  dataSearch,
});

export const getInPhieuThuChiSuccess = (data) => ({
  type: GET_IN_PHIEU_THUCHI_SUCCESS,
  payload: data,
});

export const getInPhieuThuChiFailure = () => ({
  type: GET_IN_PHIEU_THUCHI_FAILURE,
});

export const showInPhieuThuChi = (thuChiId) => ({
  type: SHOW_IN_PHIEU_THUCHI,
  thuChiId,
});
